<gosuite-lightbox
	#lightboxInstance="lightbox"
	[showHeader]="showHeader"
	[showFooter]="showFooter"
	[showCloseButton]="showCloseButton"
	[showBackground]="showBackground"
	[backgroundColor]="backgroundColor"
	[boxColor]="boxColor"
	[showBoxShadow]="showBoxShadow"
	[closeByCloseButtonClick]="false"
	[closeByBackgroundClick]="false"
	[closeOnEscapeKey]="false"
	[boxWidth]="boxWidth"
	[boxHeight]="boxHeight"
	[isFancy]="isFancy"
	[closeButtonFixed]="closeButtonFixed"
	(onOpen)="handleLightboxOpen()"
	(onClose)="handleLightboxClose()"
	(onClickCloseButton)="handleClickCloseButton()"
	(onClickBackground)="handleClickBackground()"
	(onEscapeKeyPress)="handleEscapeKeyPress()"
>
	<div class="lightbox-body">

		<div class="preloader-wrapper" *ngIf="showLoader && !signCode"><bar-loader></bar-loader></div>

		<iframe [src]="frameUrl" #frame [hidden]="showLoader || signCode"></iframe>

		<div *ngIf="signCode" class="sign-code">

			<p>
				<gosuite-select
					placeholder="Basis-Url"
					i18n-placeholder="@prrlWebsiteBaseUrl"
					[items]="urls"
					[(ngModel)]="selectedUrl"
				></gosuite-select>
			</p>

			<p><a target="_blank" [href]="selectedUrl.value">{{selectedUrl.value}}</a></p>

			<p i18n="@@signPinCodeInfo">Bitte diesen Code zum Unterschreiben des Formblatts verwenden:</p>
			<p class="code">{{signCode}}</p>

			<p>
				<ng-container i18n="PRRL Sign doc link for email@@prrlEmailLinkInfo">Alternativ können Sie diesen Link zum Unterschreiben per E-Mail an Ihren Kunden senden:</ng-container><br />
				<a target="_blank" [href]="selectedUrl.value + '/' + uuid">{{selectedUrl.value}}/{{uuid}}</a>
			</p>
		</div>
	</div>

	<footer class="lightbox-footer">
		<div class="buttons">
			<gosuite-button i18n-label="@@storeDocumentAndSign" [primary]="false" label="In Ablage speichern und als unterschrieben kennzeichnen" (onClick)="storeDocumentAndSign()"></gosuite-button>
			<gosuite-button i18n-label="@@storeDocumentGetPin" [primary]="true" label="In Ablage speichern und Code zum Signieren generieren" (onClick)="storeDocument()"></gosuite-button>
		</div>
	</footer>
</gosuite-lightbox>



// WEBPACK FOOTER //
// ./src/app/shared/components/prrl-form-butler-dialog/prrl-form-butler-dialog.component.html